import { withTranslation } from "next-i18next";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import ClosetItemsList from "@components/core/ClosetItemsList";

function DrawerClosetInPreparation({ t }) {
  const currentCloset = useCustomizableCloset();

  return (
    <div>
      <div className="d-flex flex-column align-items-center bg-white py-3 px-4 text-center">
        <h5 className="px-2 mb-2">
          {t('common:drawer.modal_closet_in_preparation.your_closet_is_coming')}
        </h5>
        <p className="px-2 mb-0 text-gray">
          {t('common:drawer.modal_closet_in_preparation.we_prepare_it')}
        </p>
      </div>

      <div className="m-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>
  );
};


export default withTranslation("common")(DrawerClosetInPreparation);
